export default __webpack_public_path__ + "static/media/Foot_right.2ed4a72e.svg";